<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/studyabroad' }"
        >升学规划</el-breadcrumb-item
      >
      <el-breadcrumb-item>留学调研</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="maximal">
      <div class="content">
        <div class="header">
          <div class="but">
            <button @click="go()">出国留学方向升学指导</button>
          </div>
          <div class="title">出国留学介绍</div>
          <div class="specification">
            什么是出国留学？为什么要选择出国留学？哪些人适合出国留学？出国留学有哪些途径？有哪些学校？需要做什么？
          </div>
        </div>
        <div class="middle">
          <div class="title">出国留学途径</div>
          <div class="details">
            <p>
              1、是海外高中或预科路线，学生自己通过各种办法申请到海外的高中或预科，然后向目前就读的学校申请肄业，后面就直接走海外大学申请流程。
            </p>
            <p>
              2、是自己找留学中介申请，这是现在非国际课程班学生的主流选择。这些同学从高一暑假甚至更早就已经有出国留学的计划（也有高二暑假才决定的，但已经非常仓促了）。他们需要准备申请材料以及SAT、ACT、IELTS、TOEFL等标化考试，高二暑假还会去报国外一些著名大学的夏校项目。利用夏校的机会到国外，一方面希望能够未来进到这个大学，另一方面也可以有机会游览一些名校，多些选择。但这样要同时兼顾国内课程和国外大学需要的申请材料，是很辛苦的。
            </p>
            <p>
              3、路是海外大学与学校签订的绿色通道协议，大学招生部门可以有专门的校测来直接进行选拔录取工作，但这是上海少数高中的特殊待遇。不过这些大学的水平只能中等偏上吧，世界最顶尖大学当然是不大可能了，但也算是一个出国保底校的机会。
            </p>
            <p>
              4、其实还有第四条路，就是拿着国内的高考成绩，去申请海外的大学，但走这条路的人目前并不多。但随着中国在国际上地位的不断提升，相信也会有越来越多的同学可以走这条路。
            </p>
          </div>
        </div>
        <div class="body">
          <div class="bod_title">出国留学时间规划</div>
          <div class="state_box">
            <div
              class="state"
              :class="isactive === ind ? 'active' : ''"
              @click="getTime(it.code, ind)"
              v-for="(it, ind) in data"
              :key="ind"
            >
              {{ it.name }}
            </div>
          </div>
          <div v-if="timelineList.length != 0">
            <div class="time" v-for="(item, ind) in timelineList" :key="ind">
              <div class="time_title">
                <div>{{ item.startTimeAxis }}</div>
              </div>
              <div class="timeline">
                <TimelineState :timelineList="item.busStudyAbroadTimeAxes" />
              </div>
            </div>
          </div>
          <div v-else class="none">
            <el-empty description="暂无数据，敬请期待"></el-empty>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimelineState from "@/components/TimelineState/Timeline.vue";
import { GetStudyAbroads, GetBusStudyAbroadTimeAxes } from "@/api/home";
export default {
  name: "XExpertteam",
  components: {
    TimelineState,
  },
  data() {
    return {
      isactive: 0,
      timelineList: [],
      data: "",
    };
  },

  async mounted() {
    const res = await GetStudyAbroads("340856133152837");
    this.data = res.data||res.result;
    this.getTime("1001", 0);
  },

  methods: {
    go() {
      this.$router.push("/questionnaire");
    },
    async getTime(CountryId, index) {
      const res = await GetBusStudyAbroadTimeAxes(CountryId);
      this.timelineList = res.data||res.result;
      this.isactive = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/global.less";
.maximal {
  width: 100%;
  margin-top: 10px;
  min-width: 1050px;
  .content {
    .header {
      position: relative;
      width: 100%;
      height: 165px;
      background: #ffffff;
      border-radius: 3px 3px 3px 3px;
      opacity: 1;
      .but {
        position: absolute;
        top: 23px;
        right: 44px;
        button {
          cursor: pointer;
          width: 226px;
          height: 35px;
          background: #3964e6;
          border-radius: 3px 3px 3px 3px;
          border: 0px;
          color: #fff;
          font-size: 16px;
          font-weight: bold;
        }
      }
      .title {
        padding-top: 5%;
        padding-left: 1%;
        font-size: 22px;
        color: #333;
        font-weight: bold;
      }
      .specification {
        padding-top: 11px;
        padding-left: 1%;
        font-size: 14px;
        color: #666;
      }
    }
    .middle {
      width: 100%;
      height: 450px;
      background: #ffffff;
      border-radius: 3px 3px 3px 3px;
      opacity: 1;
      margin-top: 32px;
      padding: 18px 0;
      padding-left: 1%;
      .title {
        font-size: 22px;
        font-weight: bold;
        color: #333;
      }
      .details {
        font-size: 14px;
        color: #666;
        width: 90%;
        height: 212px;
        line-height: 42px;
        p {
          margin-top: 5px;
        }
      }
    }
    .body {
      width: 100%;
      height: 100%;
      background: #fff;
      margin-top: 32px;
      .bod_title {
        font-size: 22px;
        color: #333;
        font-weight: bold;
        padding-left: 1%;
        margin-bottom: 35px;
        padding-top: 21px;
      }
      .state_box {
        display: flex;
        margin-left: 40px;
        .state {
          width: 64px;
          height: 32px;
          color: #333;
          font-size: 14px;
          text-align: center;
          line-height: 32px;
          margin: 0 23px;
          cursor: pointer;
        }
        .active {
          background: #3964e6;
          border-radius: 38px 38px 38px 38px;
          opacity: 1;
          border: 1px solid #3964e6;
          color: #fff;
        }
      }
      .none {
        width: 100%;
        height: 100%;
      }
      .time {
        width: 100%;
        height: 100%;
        .time_title {
          font-size: 20px;
          width: 95%;
          height: 44px;
          background: #e3e9fb;
          opacity: 1;
          border-radius: 80px 80px 80px 80px;
          margin: 37px auto;
          line-height: 44px;
          div {
            margin-left: 59px;
          }
        }
        .timeline {
          padding-top: 20px;
        }
      }
    }
  }
}
</style>